<script setup lang="ts">
import { useLang } from '@/composables/use-lang'
import { pinia } from '@/stores'
import { useRemoteDiagnose } from '@/stores/remote-diagnose'
import ScheduleAppointmentResultContent from '@/lang/schedule-appointment-result.json'

const { state } = useRemoteDiagnose(pinia)
const langContent = useLang(ScheduleAppointmentResultContent)
</script>

<template>
  <div class="text-center">
    <h2 class="mb-10">{{ langContent.appointment_scheduled }}</h2>
    <p>
      {{ langContent.thank_you_message }}
      <strong>{{ state.date }}</strong
      >{{ langContent.time_label }}
      <strong>{{ state.time }}</strong>
    </p>
    <p>{{ langContent.contact_message }}</p>
    <p>{{ langContent.see_you_soon }}</p>
  </div>
</template>
